import React, { useEffect, useState } from 'react'
import { database, databaseRef } from 'utils/firebase'
import { onValue, update } from 'firebase/database'
import { useAlert } from 'react-alert'
import styles from '../../styles.module.scss'
import AddModal from './AddModal/addModal'
import classNames from 'classnames'
import { MdDeleteOutline, MdOutlineModeEdit } from 'react-icons/md'
import { useSelector } from 'react-redux'
import { addDoctorLog } from 'utils/functions'

const ImageTemplates = () => {
  const [addTemplateOpen, setAddTemplateOpen] = useState(false)
  const [editTemplateOpen, setEditTemplateOpen] = useState(false)
  const [templates, setTemplates] = useState(null)
  const [fetched, setFetched] = useState(false)
  const [editKey, setEditKey] = useState(null)
  const alert = useAlert()
  const [searchString, setSearchString] = useState('')
  const { me } = useSelector((state) => state.app)

  useEffect(() => {
    const templatesRef = databaseRef(database, 'templates/imaging')
    const unsubscribe = onValue(templatesRef, (snapshot) => {
      setTemplates(snapshot.val() || null)
      setFetched(true)
    })
    return () => unsubscribe()
  }, [])

  const toggle = (ref) => {
    ref((v) => !v)
  }

  const editTemplate = (key) => {
    setEditKey(key)
    setEditTemplateOpen(true)
  }

  const deleteTemplate = (key) => {
    const confirmed = window.confirm(
      'Are you sure you want to delete this template?',
    )
    if (confirmed) {
      const templateName = templates[key]?.name || 'Unknown Template'
      const updates = {}
      updates[`templates/imaging/${key}`] = null
      update(databaseRef(database), updates)
        .then(() => {
          alert.success('Deleted')
          addDoctorLog({
            action: 'DELETE_IMAGING_TEMPLATE',
            category: 'template',
            doctorID: me.id,
            description: `Deleted imaging template: ${templateName}`,
            details: {
              templateId: key,
              templateName: templateName,
              timestamp: Date.now()
            }
          })
        })
        .catch(error => {
          console.error('Error deleting template:', error)
          alert.error('Failed to delete template')
        })
    }
  }

  return (
    <div className={styles.bodyRoot}>
      <div className="d-flex justify-content-between align-items-center">
        <label
          htmlFor="name"
          className={classNames('d-flex flex-column w-50', styles.title)}
          // className={styles.title}
        >
          Search template :
          <input
            type="text"
            name="name"
            id="name"
            onChange={(e) => setSearchString(e.target.value)}
          />
        </label>

        <button
          type="button"
          className={styles.button}
          onClick={() => toggle(setAddTemplateOpen)}
        >
          Add template
        </button>
      </div>

      {fetched &&
        templates &&
        Object.keys(templates).map((key) => {
          const template = templates[key]
          if (
            template.name.toLowerCase().includes(searchString.toLowerCase())
          ) {
            return (
              <div key={key} className={styles.templateItem}>
                <div className={styles.templateName}>
                  <span>{template.name}</span>
                </div>
                <div className={styles.actionButtons}>
                  <MdOutlineModeEdit
                    size={20}
                    color="#9393AA"
                    cursor={'pointer'}
                    className={styles.editIcon}
                    onClick={() => editTemplate(key)}
                  />

                  <MdDeleteOutline
                    size={20}
                    color="#9393AA"
                    cursor={'pointer'}
                    className={styles.deleteIcon}
                    onClick={() => deleteTemplate(key)}
                  />
                </div>
              </div>
            )
          }
          return null
        })}

      {fetched && !templates && (
        <div className="d-flex justify-content-center align-items-center h-100">
          <span className={styles.title}>No templates found</span>
        </div>
      )}

      {addTemplateOpen && (
        <AddModal
          isOpen={addTemplateOpen}
          closeModal={() => setAddTemplateOpen(false)}
          edit={false}
        />
      )}

      {editTemplateOpen && (
        <AddModal
          isOpen={editTemplateOpen}
          closeModal={() => setEditTemplateOpen(false)}
          edit={true}
          editKey={editKey}
          templates={templates}
        />
      )}
    </div>
  )
}

export default ImageTemplates
